export default {
	events: {
		'ddc.link.generic': [
			{
				logic: {
					widgetClasses: 'tagging-view-inventory'
				},
				payload: () => ({
					directCall: 'global-onclick',
					payload: {
						onclick: {
							onclick: 'bluecruise:content:view inventory',
							onclickLinkName: 'bluecruise:content:action'
						}
					}
				})
			},
			{
				logic: {
					widgetClasses: 'tagging-learn-more'
				},
				payload: () => ({
					directCall: 'referral-exit',
					payload: {
						event: {
							action: 'brand referral'
						},
						onclick: {
							onclick: 'referral:fv:bluecruise',
							referredTo: 'fv:bluecruise',
							onclickLinkName: 'referral:exit'
						}
					}
				})
			}
		]
	}
};
